import React from 'react'

import { EMPTY_DISPLAY_VALUE } from '../../../utilities/helpers'

export default function DetailList({ rows }) {
  return (
    <dl className="mb-0">
      {rows.filter(Boolean).map((row) => (
        <div
          key={row.label}
          className="d-flex justify-content-between align-items-start gap-3 py-2 border-bottom"
        >
          <dt className="text-muted fw-medium mb-0">{row.label}</dt>
          <dd className="mb-0 text-end">{row.value ?? EMPTY_DISPLAY_VALUE}</dd>
        </div>
      ))}
    </dl>
  )
}
